import DceJsx from "./DceJsx";
import JsxBindReflectMetadata from "./reflection/JsxBindReflectMetadata";
import JsxBindClassMetadata from "./reflection/JsxBindClassMetadata";

export default abstract class DceJsxRenderer {

    private _jsxBindMetadata: JsxBindClassMetadata = null;

    private _mutationObserver: MutationObserver;

    private _root: HTMLElement;

    protected _attachBindObserver = false;

    constructor(attachBindObserver: boolean = false) {
        this._attachBindObserver = attachBindObserver;
    }

    /**
     * Renderuje kawałek HTML'a
     */
    public abstract render():JSX.Element

    get jsxBindMetadata(): JsxBindClassMetadata {
        if(null == this._jsxBindMetadata){
            this._jsxBindMetadata = JsxBindReflectMetadata.getInstance().getMetadata(this);
        }
        return this._jsxBindMetadata;
    }

    get root(): HTMLElement {
        return this._root;
    }

    public bindByRefMetadata(ref:string, elem: HTMLElement){
        this.jsxBindMetadata.fillProperties(this, ref, elem);
    }

    public bindByRef(ref:string, elem: HTMLElement){
    }

    public insertBefore(elem:HTMLElement): HTMLElement{
        let newElem = this.generateElement();
        elem.parentElement.insertBefore(newElem, elem);
        return newElem;
    }

    public insertAfter(elem:HTMLElement): HTMLElement{
        let newElem = this.generateElement();
        elem.parentElement.insertBefore(newElem, elem.nextSibling);
        return newElem;
    }

    /**
     * Dodaje render do elementu
     * @param elem
     */
    public appendTo(elem: HTMLElement): HTMLElement{
        let newElem = this.generateElement();
        elem.append(newElem);
        return newElem;
    }

    /**
     * Dodaje render do elementu
     * @param elem
     */
    public prependTo(elem: HTMLElement): HTMLElement{
        let newElem = this.generateElement();
        elem.prepend(newElem);
        return newElem;
    }

    /**
     * Zamienia content elementu na net z metody render
     * @param elem
     */
    public fill(elem: HTMLElement):HTMLElement{
        elem.innerText = '';
        return this.appendTo(elem);
    }

    public generateElement(): HTMLElement{
        DceJsx.pushContextObj(this);
        let e = this.render() as unknown as HTMLElement;
        DceJsx.popContextObj();

        this._root = e;

        if(this._attachBindObserver) {
            this._mutationObserver = new MutationObserver((mutations: MutationRecord[], observer: MutationObserver) => {
                this.mutationCallback();
            });

            this._mutationObserver.observe(e, {
                attributeFilter: ['ref'],
                attributes: true,
                characterData: false,
                childList: true,
                subtree: true
            });

        }

        return e;
    }

    protected mutationCallback(): void{
        console.log("BINDINGS  MUTATION ECECUTE");

        this.jsxBindMetadata.clearProperties(this);
        let selected = this._root.querySelectorAll('*[ref]');

        selected.forEach(e => {
            let htmlElem = e as HTMLElement;
            console.log("REFED ELEMENT", e, e.getAttribute("ref"));

            this.jsxBindMetadata.fillProperties(this, e.getAttribute("ref"), htmlElem);
        });
    }

}